import { GatsbyImage } from "gatsby-plugin-image"
import React, { useEffect } from "react"
import Spacer from "./spacer"

export default function HeroBanner({ image, mobileImage, caption, captionTwo, subtitle, videoUrl, thankYou }) {
    useEffect(() => {
        const handleScroll = () => {
            const bgElement = document.querySelector(".bg-image")
            const scrollIndicator = document.querySelector(".scroll--indicator")
            if (window.scrollY > 100) {
                bgElement.classList.add("filter-08")
            } else {
                bgElement.classList.remove("filter-08")
            }
        }
        window.addEventListener("scroll", handleScroll)
        return () => window.removeEventListener("scroll", handleScroll)
    }, [])

    return (
        <div className='h-100vh bg-grey pos-rel flex flex-col m-overflow'>
            <Spacer className='mt20 m-mt60 pos-rel z-2' />
            <div className='pos-rel z-2 ma text-center'>
                <p className='h1 white-space fade--up delay-100' data-sal>
                    {caption}
                </p>
                <div className='p40 flex align-center justify-center fade--up delay-150' data-sal>
                    <div className='dot' />
                </div>
                <p className='h2 white-space fade--up delay-200' data-sal>
                    {captionTwo}
                </p>
            </div>
            <div className='pos-rel z-2 mb40 m-p20 m-mb-20 m-balance text-center'>
                <div data-sal dangerouslySetInnerHTML={{ __html: subtitle }} className='sm-copy white-space fade--up delay-200' />
            </div>
            <div>
                {videoUrl ? (
                    <video className='bg-image will-darken fixed-bg' autoPlay muted loop playsInline>
                        <source src={videoUrl} type='video/mp4' />
                        {image && <GatsbyImage image={image?.gatsbyImageData} alt='Hero Image' className='bg-image will-darken fixed-bg' />}
                    </video>
                ) : (
                    <>
                        <div className={mobileImage ? "m-hide" : ""}>
                            <GatsbyImage image={image?.gatsbyImageData} alt='Hero Image' className='bg-image will-darken fixed-bg' />
                        </div>
                        {mobileImage && (
                            <div className='m-show'>
                                <GatsbyImage image={mobileImage?.gatsbyImageData} alt='Hero Image' className='bg-image will-darken fixed-bg' />
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    )
}
